import { JackGirderConnection } from '@paragon/contract-library';

export const getRecursiveJackGuidsForComponent = (
  designGuid: string,
  connections: JackGirderConnection[],
  visited = new Set<string>(),
) => {
  if (visited.has(designGuid)) {
    throw new Error(`Cycle detected while collecting recursive jack guids for component ${designGuid}.`);
  }

  visited.add(designGuid);

  const componentConnections = connections.filter((connection) => connection.girderGuid === designGuid);
  const directJackGuids = new Set<string>();
  for (const connection of componentConnections) {
    directJackGuids.add(connection.jackGuid);
  }

  try {
    const allJackGuids = new Set<string>(directJackGuids);
    for (const directJackGuid of directJackGuids) {
      const descendants = getRecursiveJackGuidsForComponent(directJackGuid, connections, visited);
      for (const descendant of descendants) {
        allJackGuids.add(descendant);
      }
    }

    return Array.from(allJackGuids);
  } finally {
    // Always unwind recursion-path state so sibling branches are evaluated independently.
    visited.delete(designGuid);
  }
};
